/* eslint-disable default-param-last */
import packetState from 'models/packet';
import { PACKET_ACTIONS } from 'actions/packet';

const PacketReducer = (state = packetState, action) => {
  switch (action.type) {
    case PACKET_ACTIONS.GET_INDEXING:
      return {
        ...state,
        indexing: action.payload,
        attributesArray: action.attributeData
      };
    case PACKET_ACTIONS.GET_NEXT_PACKET_ID:
      return {
        ...state,
        packetId: action.payload
      };
    case PACKET_ACTIONS.GET_PACKET_COMMUNICATION:
      return {
        ...state,
        packetComments: action.payload
      };
    case PACKET_ACTIONS.GET_TRACKINGCODE_STATUS:
      return {
        ...state,
        trackingCodeStatus: action.payload
      };
    case PACKET_ACTIONS.TOGGLE_ADDITIONAL_DETAILS_EDIT:
      return {
        ...state,
        additionalDetailsEdit: action.payload
      };
    case PACKET_ACTIONS.CLEAR_TRACKINGCODE_STATUS:
      return {
        ...state,
        trackingCodeStatus: []
      };
    default:
      return state;
  }
};

export const getAttributesArraySelector = (state) => state.packet.attributesArray;

export default PacketReducer;
